module.exports = __webpack_public_path__ + "img/userplus.9437a449.png";